<template>
    <div class="title">
        <em class="el-icon-arrow-left" :style="{color: titleColor}"></em>
        <h3><span :style="{color: titleColor}">个人中心</span></h3>
    </div>
</template>
<script>
export default {
    props: ['titleColor']
}
</script>
<style lang="scss" scoped>
    .title{
        display: flex;
        line-height: 48px !important;
        align-items: center;
        font-size: 14px;
        em{
            margin-left: 12px;
        }
        h3{
            margin-left: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// website/subComponents/sdk/style/DiyTitle.vue